import React, {FC} from 'react';
import styles from './Teams.module.scss';
import {Helmet} from "react-helmet";

interface TeamsProps {
}

const Teams: FC<TeamsProps> = () => (
    <div className={styles.Teams}>
        <Helmet>
            <meta charSet="utf-8"/>
            <title>Teams</title>
        </Helmet>
        <div className="standard-margin">
            <h1> Contact Us</h1>
            <hr></hr>

            <h3>Microsoft Teams</h3>

            Join <a
            href="https://teams.microsoft.com/l/team/19%3a34e72619e8fd4dd19b7327a3d0ade5d2%40thread.skype/conversations?groupId=a76d698b-c933-4449-8211-b40058fe083d&amp;tenantId=0693b5ba-4b18-4d7b-9341-f32f400a5494"
            target="_blank" id="anch_36">
            <abbr title="electronic Technical Information Center">eTIC</abbr> Web Chat</a> Monday – Friday, 8 a.m. – 4
            p.m. MST

            <br></br>
            <br></br>
            <h3>Email</h3>
            Send us questions, comments, suggestions, or report issues to <a href="mailto:etic@nps.gov" id="anch_37">etic@nps.gov</a>
            <br></br>     <br></br>
            <h3>Phone</h3>
            General information: 303‑969‑2130
            <br></br>     <br></br>
            <h3>Mail</h3>
            <b>Technical Information Center</b><br></br>
            NPS Denver Service Center<br></br>
            P.O. Box 25287<br></br>
            Denver CO 80225‑0287
            <br></br> <br></br>
            Shipping Address (Street):
            <br></br>
            DSC, Technical Information Center<br></br>
            National Park Service<br></br>
            One Denver Federal Center Building 50<br></br>
            Denver, CO 80225-0047
            <br></br>     <br></br>     <br></br>     <br></br>     <br></br>
        </div>
    </div>
);

export default Teams;
